import { DatePickerProps } from '../components/date-picker';

export const getDatePicker =
  <T>(data: Omit<DatePickerProps<T>, 'type'>) =>
    (): DatePickerProps<T> => ({
      ...data,
      type: 'date-picker',
    });
